import React from 'react';
import { StyledEmptyCard, StyledEmptyIcon, StyledEmptyText } from './empty.style';

export interface EmptyProps {
    text: string;
    id?: string
}

const Empty = (props: EmptyProps) => {
  return (
    <StyledEmptyCard>
        <StyledEmptyIcon/>
        <StyledEmptyText id={props.id}>
            {props.text}
        </StyledEmptyText>
    </StyledEmptyCard>
  );
};

export default Empty;